/* tslint:disable */
/* eslint-disable */
/**
 * Admin Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { OrcidScopeDTO } from './OrcidScopeDTO';
import {
    OrcidScopeDTOFromJSON,
    OrcidScopeDTOFromJSONTyped,
    OrcidScopeDTOToJSON,
    OrcidScopeDTOToJSONTyped,
} from './OrcidScopeDTO';
import type { OrcidPutCodeDTO } from './OrcidPutCodeDTO';
import {
    OrcidPutCodeDTOFromJSON,
    OrcidPutCodeDTOFromJSONTyped,
    OrcidPutCodeDTOToJSON,
    OrcidPutCodeDTOToJSONTyped,
} from './OrcidPutCodeDTO';

/**
 * 
 * @export
 * @interface OrcidAuthorizeDTO
 */
export interface OrcidAuthorizeDTO  {
    /**
     * 
     * @type {number}
     * @memberof OrcidAuthorizeDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OrcidAuthorizeDTO
     */
    orcidID?: string;
    /**
     * 
     * @type {string}
     * @memberof OrcidAuthorizeDTO
     */
    orcidClientId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrcidAuthorizeDTO
     */
    accessToken?: string;
    /**
     * 
     * @type {string}
     * @memberof OrcidAuthorizeDTO
     */
    refreshToken?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrcidAuthorizeDTO
     */
    publicUsageOfLimitedOrcidData?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrcidAuthorizeDTO
     */
    tokenRevoked?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof OrcidAuthorizeDTO
     */
    lastUpdateFromOrcid?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrcidAuthorizeDTO
     */
    authorizationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrcidAuthorizeDTO
     */
    revocationDate?: Date;
    /**
     * 
     * @type {Array<OrcidPutCodeDTO>}
     * @memberof OrcidAuthorizeDTO
     */
    employmentPutCodes?: Array<OrcidPutCodeDTO>;
    /**
     * 
     * @type {Array<OrcidScopeDTO>}
     * @memberof OrcidAuthorizeDTO
     */
    orcidScopes?: Array<OrcidScopeDTO>;
}

/**
 * Check if a given object implements the OrcidAuthorizeDTO interface.
 */
export function instanceOfOrcidAuthorizeDTO(value: object): value is OrcidAuthorizeDTO {
    return true;
}

export function OrcidAuthorizeDTOFromJSON(json: any): OrcidAuthorizeDTO {
    return OrcidAuthorizeDTOFromJSONTyped(json, false);
}

export function OrcidAuthorizeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrcidAuthorizeDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'orcidID': json['orcidID'] == null ? undefined : json['orcidID'],
                  'orcidClientId': json['orcidClientId'] == null ? undefined : json['orcidClientId'],
                  'accessToken': json['accessToken'] == null ? undefined : json['accessToken'],
                  'refreshToken': json['refreshToken'] == null ? undefined : json['refreshToken'],
                  'publicUsageOfLimitedOrcidData': json['publicUsageOfLimitedOrcidData'] == null ? undefined : json['publicUsageOfLimitedOrcidData'],
                  'tokenRevoked': json['tokenRevoked'] == null ? undefined : json['tokenRevoked'],
                'lastUpdateFromOrcid': json['lastUpdateFromOrcid'] == null ? undefined : (new Date(json['lastUpdateFromOrcid'])),
                'authorizationDate': json['authorizationDate'] == null ? undefined : (new Date(json['authorizationDate'])),
                'revocationDate': json['revocationDate'] == null ? undefined : (new Date(json['revocationDate'])),
              'employmentPutCodes': json['employmentPutCodes'] == null ? undefined : ((json['employmentPutCodes'] as Array<any>).map(OrcidPutCodeDTOFromJSON)),
              'orcidScopes': json['orcidScopes'] == null ? undefined : ((json['orcidScopes'] as Array<any>).map(OrcidScopeDTOFromJSON)),
    };
}

export function OrcidAuthorizeDTOToJSON(json: any): OrcidAuthorizeDTO {
    return OrcidAuthorizeDTOToJSONTyped(json, false);
}

export function OrcidAuthorizeDTOToJSONTyped(value?: OrcidAuthorizeDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'orcidID': value['orcidID'],
        'orcidClientId': value['orcidClientId'],
        'accessToken': value['accessToken'],
        'refreshToken': value['refreshToken'],
        'publicUsageOfLimitedOrcidData': value['publicUsageOfLimitedOrcidData'],
        'tokenRevoked': value['tokenRevoked'],
        'lastUpdateFromOrcid': value['lastUpdateFromOrcid']?.toISOString(),
        'authorizationDate': value['authorizationDate']?.toISOString(),
        'revocationDate': value['revocationDate']?.toISOString(),
        'employmentPutCodes': value['employmentPutCodes'] == null? value['employmentPutCodes']: (value['employmentPutCodes'] as Array<any>).map(OrcidPutCodeDTOToJSON),
        'orcidScopes': value['orcidScopes'] == null? value['orcidScopes']: (value['orcidScopes'] as Array<any>).map(OrcidScopeDTOToJSON),
    };
}


